import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Row,
    Typography
} from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addLinkCompany, loadAllCompanies } from "../../redux/rtk/features/linkUser/linkUserSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import LinkUserTblData from "./LinkUserTblData";

const LinkCompany = ({ drawer }) => {
    const [loader, setLoader] = useState(false);
    const [selectedJoinDate, setSelectedJoinDate] = useState(null);
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    const [selectedCompanyName, setSelectedCompanyName] = useState('');
    const userId = getUserFromToken();

    // const users = useSelector((state) => state.linkUser?.list?.map(user => ({
        

    //     // id: user.id.toString(), // Ensuring id is string for comparison
    //     id: user?.id?.toString() ?? "",
    //     company_name: user.company_name,
    //     joinDate: user.joinDate
    // })));

    var userList = [];

    const users = useSelector((state) => {
        userList = state.linkUser?.linkCompany?.map(user => ({
            // id: user.id.toString(), // Ensuring id is string for comparison
            id: user?.id?.toString() ?? "",
            company_name: user.company_name,
            joinDate: user.joinDate
        })) || [];
        return userList;
    });
    
    const dispatch = useDispatch();
    const { Title } = Typography;
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(loadAllCompanies());
    }, []);

    const onFinish = async (values) => {
        if (values.joinDate) {
            const formattedDate = moment(values.joinDate).format("YYYY-MM-DD");
            values.joinDate = formattedDate;
        }
        setLoader(true);
        const resp = await dispatch(addLinkCompany({ id: selectedCompanyId, userId: userId}));
        if (resp.payload.message === "success") {
            setLoader(false);
            form.resetFields();
            // dispatch(loadAllAttendance());
        } else {
            setLoader(false);
        }
    };

    const onFinishFailed = (errorInfo) => {
        toast.warning("Failed at updating Company information");
        setLoader(false);
    };

    const handleUserIdChange = (e) => {
        const id = e.target.value;
        setSelectedCompanyId(id);
        form.setFieldsValue({ company_name: null, joinDate: null });
        setSelectedCompanyName('');
        setSelectedJoinDate(null);
    };

    const handleUserNameChange = (e) => {
        const company_name = e.target.value;
        setSelectedCompanyName(company_name);
        const selectedUser = userList.find(user => user.id === selectedCompanyId && user.company_name === company_name);
        if (selectedUser) {
            setSelectedJoinDate(moment(selectedUser.joinDate));
        } else {
            setSelectedJoinDate(null);
        }
    };

    const isPermissionGranted = selectedCompanyId && selectedCompanyName && userList.some(user => user.id === selectedCompanyId && user.company_name === selectedCompanyName);

    console.log("selectedCompanyId:", selectedCompanyId, "selectedCompanyName:", selectedCompanyName, "isPermissionGranted:", isPermissionGranted); // Debug log

    return (
        <Fragment>
                <Row className='mr-top' justify={drawer ? "center" : "space-between"}>
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={drawer ? 22 : 12}
                        xl={drawer ? 22 : 12}
                        className='column-design border rounded card-custom'>
                        <Title level={4} className='m-2 mt-5 mb-5 text-center'>
                        Company Information
                        </Title>

                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            eventKey='shift-form'
                            name='basic'
                            labelCol={{
                                span: 6,
                            }}
                            wrapperCol={{
                                span: 12,
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete='off'>
                            <div>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Company ID'
                                    name='id'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter a Company ID!",
                                        },
                                    ]}>
                                    <Input
                                        placeholder='Enter User ID'
                                        onChange={handleUserIdChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Company Name'
                                    name='company_name'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter a user name!",
                                        },
                                    ]}>
                                    <Input
                                        placeholder='Enter Company Name'
                                        onChange={handleUserNameChange}
                                    />
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Join Date'
                                    name='joinDate'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select join date!",
                                        },
                                    ]}>
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        style={{ width: "100%" }}
                                        disabled={!isPermissionGranted}
                                    />
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    wrapperCol={{
                                        offset: 6,
                                        span: 12,
                                    }}>
                                    <Button
                                        onClick={() => setLoader(true)}
                                        type='primary'
                                        size='large'
                                        htmlType='submit'
                                        block
                                        loading={loader}
                                        disabled={!isPermissionGranted}>
                                        Update
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </Col>
                </Row>
                <Row>
                <LinkUserTblData/>
                </Row>
        </Fragment>
    );
};

export default LinkCompany;
